import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import TestimonialBox from './TestimonialBox';
import TopBar from './TopBar';

const teamMembers = [
  { name: 'Cardarion Hart', title: 'CEO', image: 'user_1.png' },
  { name: 'Gauthier Drewitt', title: 'HR Manager', image: 'user_2.png' },
  { name: 'Labeeba Al Amer', title: 'Finance Manager', image: 'user_3.png' },
  { name: 'Onyama Limba', title: 'Software Engineer', image: 'user_4.png' },
  { name: 'Athar Malakooti', title: 'CEO', image: 'user_5.png' },
  { name: 'Kung Jiyeon', title: 'HR Manager', image: 'user_6.png' },
  { name: 'Mathijn Agter', title: 'Finance Manager', image: 'user_7.png' },
  { name: 'Jontray Arnold', title: 'Software Engineer', image: 'user_8.png' },
];

const AboutPage = () => {
  return (
    <>
      <TopBar />
      <main className="page-about">
        <div className="container">
          <Navbar />
          {/* Page Header */}
          <section className="page-header">
            <h1>About</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb foi-breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About
                </li>
              </ol>
            </nav>
          </section>

          {/* Section One - Who We Are */}
          <section className="foi-page-section1 pt-0">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0 pr-lg-0">
                <h2 className="about-section-one-title">
                  Who We <span className="font-weight-normal">Are</span>
                </h2>
                <div className="about-section-one-content">
                  <p>
                    At <strong>Finance Experts</strong>, we are a team of seasoned financial
                    professionals committed to guiding individuals and businesses through their
                    financial journeys. With a foundation built on trust and performance, we deliver
                    custom financial solutions tailored to your unique goals.
                  </p>
                  <p>
                    We combine experience, data-driven insights, and integrity to provide reliable
                    advisory and financial planning services.
                  </p>
                </div>
              </div>
              <div className="col-md-6 pl-lg-0 d-flex align-items-center align-items-lg-end">
                <img
                  src="assets/images/fin1.jpg"
                  alt="Who We Are"
                  className="img-fluid"
                  width="448px"
                />
              </div>
            </div>
          </section>

          {/* Section Two - Our Core Services */}
          <section className="foi-page-section1">
            <div className="row">
              <div className="col-md-6 mb-5 mb-md-0">
                <img
                  src="assets/images/fin2.PNG"
                  alt="Core Services"
                  className="w-100 img-fluid pr-md-5"
                  width="437px"
                />
              </div>
              <div className="col-md-6">
                <h2 className="about-section-two-title">
                  Our Core <span className="font-weight-normal">Services</span>
                </h2>
                <div className="about-section-two-content">
                  <p>We offer a comprehensive range of financial services, including:</p>
                  <ul className="list-unstyled">
                    <li>
                      <i className=" text-success mr-2">✔</i>Financial Planning & Analysis
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>Tax Strategy & Compliance
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>Investment Advisory
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>Business Financial Consulting
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>Accounting & Bookkeeping
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>Risk Management
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Section Three - Our Strengths */}
          <section className="foi-page-section1 pt-0">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0 pr-lg-0">
                <h2 className="about-section-one-title">
                  Our <span className="font-weight-normal">Strengths</span>
                </h2>
                <div className="about-section-one-content">
                  <ul className="list-unstyled">
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Expertise:</strong> Multi-disciplinary team of financial specialists.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Customization:</strong> Tailored solutions to fit individual needs.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Technology-Driven:</strong> Smart tools and real-time insights.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Client-Focused:</strong> Built around your goals and success.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Results-Oriented:</strong> We focus on measurable financial growth.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 pl-lg-0 d-flex align-items-center align-items-lg-end">
                <img
                  src="assets/images/FIN3.jpeg"
                  alt="Our Strengths"
                  className="img-fluid"
                  width="448px"
                />
              </div>
            </div>
          </section>

          {/* Section Four - Our Philosophy */}
          <section className="foi-page-section1">
            <div className="row">
              <div className="col-md-6 mb-5 mb-md-0">
                <img
                  src="assets/images/fin41.png"
                  alt="Our Philosophy"
                  className="w-100 img-fluid pr-md-5"
                  width="437px"
                />
              </div>
              <div className="col-md-6">
                <h2 className="about-section-two-title">
                  Our <span className="font-weight-normal">Philosophy</span>
                </h2>
                <div className="about-section-two-content">
                  <p>
                    We believe that financial clarity empowers confidence. Our approach is holistic,
                    blending strategic planning with ethical practices to deliver long-term
                    financial well-being for our clients.
                  </p>
                  <p>
                    We measure success not just by returns, but by the confidence our clients gain
                    in managing their financial futures.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section Five - Our Values */}
          <section className="foi-page-section1 pt-0">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0 pr-lg-0">
                <h2 className="about-section-one-title">
                  Our <span className="font-weight-normal">Values</span>
                </h2>
                <div className="about-section-one-content">
                  <ul className="list-unstyled">
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Integrity</strong>: Always doing what's right.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Excellence</strong>: Precision and dedication in every task.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Transparency</strong>: Clear, honest communication.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Accountability</strong>: Taking full responsibility.
                    </li>
                    <li>
                      <i className=" text-success mr-2">✔</i>
                      <strong>Innovation</strong>: Adapting and leading with new ideas.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 pl-lg-0 d-flex align-items-center align-items-lg-end">
                <img
                  src="assets/images/fin4.png"
                  alt="Our Values"
                  className="img-fluid"
                  width="448px"
                />
              </div>
            </div>
          </section>

          {/* Section Six - Our Vision */}
          <section className="foi-page-section1">
            <div className="row">
              <div className="col-md-6 mb-5 mb-md-0">
                <img
                  src="assets/images/fin5.png"
                  alt="Our Vision"
                  className="w-100 img-fluid pr-md-5"
                  width="437px"
                />
              </div>
              <div className="col-md-6">
                <h2 className="about-section-two-title">
                  Our <span className="font-weight-normal">Vision</span>
                </h2>
                <div className="about-section-two-content">
                  <p>
                    To become the most trusted and innovative financial partner, transforming the
                    way individuals and businesses achieve financial success.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section Seven - Our Mission */}
          <section className="foi-page-section1 pt-0">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0 pr-lg-0">
                <h2 className="about-section-one-title">
                  Our <span className="font-weight-normal">Mission</span>
                </h2>
                <div className="about-section-one-content">
                  <p>
                    To deliver exceptional financial services through innovation, accuracy, and
                    client-centered strategies that foster trust, growth, and peace of mind for
                    every client we serve.
                  </p>
                </div>
              </div>
              <div className="col-md-6 pl-lg-0 d-flex align-items-center align-items-lg-end">
                <img
                  src="assets/images/fin6.jpg"
                  alt="Our Mission"
                  className="img-fluid"
                  width="448px"
                />
              </div>
            </div>
          </section>

          {/* Team Section */}
          {/* <section className="foi-page-section mb-5">
          <h5 className="text-center font-os mb-0">The amazing team</h5>
          <h2 className="team-section-title">Our Creative Minds</h2>
          <div className="row">
            {teamMembers.map((member, idx) => (
              <div className="col-md-3 mb-5" key={idx}>
                <div className="team-member-card">
                  <img
                    src={`assets/images/user/${member.image}`}
                    alt={member.name}
                    className="team-member-avatar"
                  />
                  <h6 className="mb-0">{member.name}</h6>
                  <p className="team-member-designation">{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        </section> */}
          {/* <TestimonialBox/> */}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
